export default "__VITE_ASSET__F5jZd8gh__"